import arch1 from "../assets/architecture1.jpg";
import arch2 from "../assets/architecture2.png";
export const teamMember = [
  { name: "Smita Taraphdar", designation: "BSG" },
  { name: "Praful Dhone", designation: "Tech Lead" },
  { name: "Sadashiv Borkar", designation: "Tech Lead" },
];
export const features = [
  {
    title: "No-Code Interface",
    description: "Enables domain experts to experiment without coding.",
  },
  {
    title: "Multi-Modal Support",
    description: "Works with documents, images, Excel sheets, and databases.",
  },
  {
    title: "Prompt Engineering Tools",
    description: "Create, save, and manage prompts for consistent outputs.",
  },
  {
    title: "Guardrails",
    description:
      "Includes PII redaction and security controls for safe experimentation.",
  },
  {
    title: "Data Connectivity",
    description:
      "Connect to enterprise sources like Vector, SQL, and Graph databases for contextual responses.",
  },

  {
    title: "Admin Console",
    description: "To add, remove, block the user from Playground App",
  },
];

export const techStack = [
  { title: "React (Vite)", description: "Frontend" },
  { title: "Python", description: "Backend" },
  { title: "MongoDB ", description: " NoSQL for Admin Console " },
  { title: "PostgreSQL", description: "VectorDB" },
  { title: "Entra ID", description: "Authentication" },
];

export const tabs = [
  { value: "features", label: "Features" },
  { value: "tech", label: "Tech Stack" },
  { value: "architecture", label: "Architecture" },
  { value: "demo", label: "Demo" },
];
export const architectureimage = [
  { src: arch1, altl: "Architecture 1" },
  { src: arch2, altl: "Architecture 2" },
];
